import { FormControl, ValidatorFn } from '@angular/forms';

export class TextValidators {

  static maxText(limit: number): ValidatorFn {
    return (formControl: FormControl): { [key: string]: boolean } | null => {

      if (!formControl.value) {
        return null;
      }

      let html = String(formControl.value);

      html = html.replace(/<[^>]+>/gm, ''); // Remove HTML tags

      const textarea = document.createElement('textarea');
        textarea.innerHTML = html;
        let textContent = textarea.value;

      textContent = textContent
        .replace(/&nbsp;/gi, '') // Remove non-breaking spaces
        .replace(/(\r\n|\n|\r)/gm, ''); // Remove line breaks

      return textContent.length <= limit ? null : { 'maxtext': true };
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/validators/text.validator.ts